import React from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CurrencyFormat from '../../../Helpers/Formatters/CurrencyFormat';

import '../../Quoter.scss';

export default function ProductInfoDialog(props) {

	const QuoteableTerms = [10, 15, 20, 25, 30, 35, 40]
	const GetTermsString = (terms) => {
		let termsString = "";
		if (terms) {
			let validTerms = terms.filter(element => QuoteableTerms.includes(element));
			validTerms.forEach(function (item, index) {
				if (validTerms.length === index + 1) {
					termsString = termsString + "and " + item;
				}
				else {
					termsString = termsString + item + ", ";
				}
			});
		}
		return termsString;
	}

	return (
		<div>
			<Dialog open={props.open} onClose={props.onProductInfoDialogClosed} scroll="body">
				<DialogContent className="product-info-dialog-content">
					<IconButton className="product-info-close-button" aria-label="close" onClick={props.onProductInfoDialogClosed}>
						<CloseIcon />
					</IconButton>

					<h4>{props.productName}</h4>
					<p><span dangerouslySetInnerHTML={{ __html: props.productDescription }} /></p>

					<p><strong>For Individuals Seeking the Following:</strong></p>
					<ul>
						<li>Issue ages: {props.quoteRanges && props.quoteRanges.minAge}-{props.quoteRanges && props.quoteRanges.maxAge}</li>
						<li>Term periods include {GetTermsString(props.quoteRanges && props.quoteRanges.terms)}</li>
						<li>Coverage amounts available:  $<CurrencyFormat number={props.quoteRanges && props.quoteRanges.minFace && parseFloat(props.quoteRanges.minFace)} /> - ${props.quoteRanges && props.quoteRanges.maxFace > 3000000 ? "3M+" : <CurrencyFormat number={props.quoteRanges && props.quoteRanges.maxFace && parseFloat(props.quoteRanges.maxFace)} />}</li>
						{props.hasPermConversion ? <li>Convertible to permanent life insurance</li> : null}
						<li>Fixed premiums</li>
					</ul>
				</DialogContent>
			</Dialog>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Cards/ProductInfoDialog.js